import { call, put, takeLatest } from "redux-saga/effects";
import { setLoaderAction } from "../reducers/mmymSlice";
import { callAPI, handleError, handleSuccess } from "../api/api";

import { addPayConfirmationAction, addPaymentAction, getAllPaymentListAction, getPayConfirmationListAction, paymentDeletedAction, setAddPayConfirmationResponse, setAddPaymentResponse, setAllPaymentListAction, setPayConfirmationListAction, setPaymentDeletedResponse } from "../reducers/paymentSlice";

/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllPaymentListSaga(payload: { payload: string }): any {
    yield put(setLoaderAction(true))
    console.log('plans-try',payload);
    try {
      const invoiceNo = payload?.payload;
        const res = yield call<any>(callAPI, {}, 'get', `account/payments?invoice_number=${invoiceNo}`)
        console.log('plans-', res)
        if (res?.data) {
            yield put(setAllPaymentListAction(res?.data))
        }
    } catch (error:any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response, [401]);
        error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false))  
} 

function* addPaymentSaga(payload: any[]):any {
    yield put(setLoaderAction(true))
    try {
      console.log("payload", payload);
        const apiResponse = yield call<any>(callAPI, payload, 'post', 'account/payments')
        console.log('changePassword-', apiResponse)
        if (apiResponse?.success === true) {
          apiResponse && handleSuccess(apiResponse);
            yield put(setAddPaymentResponse(true));
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setAddPaymentResponse(false));
    }
    yield put(setLoaderAction(false))
}

function* paymentDeletedSaga(payload: { payload: { selectedPaymentId: string; [key: string]: any } }): any {
    console.log("payload", payload);
    const { selectedPaymentId, ...rest } = payload?.payload || {};
    yield put(setLoaderAction(true))
    try {
        const apiResponse = yield call<any>(callAPI, {payload : rest}, 'delete', `account/payments/${selectedPaymentId}`)
        console.log('changePassword-', apiResponse)
        if (apiResponse?.success === true) {
            apiResponse && handleSuccess(apiResponse);
            yield put(setPaymentDeletedResponse(true));
        }
    } catch (error: any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setPaymentDeletedResponse(false));
    }
    yield put(setLoaderAction(false))
}
// pay confirmation sagas

function* getPayConfirmationListSaga(payload: { payload: string }): any {
    yield put(setLoaderAction(true))
    console.log('plans-try',payload);
    try {
      const date = payload?.payload;
        const res = yield call<any>(callAPI, {}, 'get', `account/pay-confirmations?date=${date}`)
        console.log('plans-', res)
        if (res?.data) {
            yield put(setPayConfirmationListAction(res?.data))
        }
    } catch (error:any) {
        console.log('Catch Error-', error)
        error?.response && handleError(error?.response, [401]);
        error?.code === "ERR_NETWORK" && handleError(error);
    }
    yield put(setLoaderAction(false))  
}

function* addPayConfirmationSaga(payload: any[]):any {
    yield put(setLoaderAction(true))
    try {
        const apiResponse = yield call<any>(callAPI, payload, 'post', 'account/pay-confirmations')
        if (apiResponse?.success === true) {
          apiResponse && handleSuccess(apiResponse);
            yield put(setAddPayConfirmationResponse(true));
        }
    } catch (error: any) {
        error?.response && handleError(error?.response);
        error?.code === "ERR_NETWORK" && handleError(error);
        yield put(setAddPayConfirmationResponse(false));
    }
    yield put(setLoaderAction(false))
}

export function* watchPayment() {
    yield takeLatest<any>(getAllPaymentListAction, getAllPaymentListSaga);
    yield takeLatest<any>(addPaymentAction, addPaymentSaga);
   yield takeLatest<any>(paymentDeletedAction, paymentDeletedSaga);
   yield takeLatest<any>(getPayConfirmationListAction, getPayConfirmationListSaga);
   yield takeLatest<any>(addPayConfirmationAction, addPayConfirmationSaga);
}